import { useEffect } from 'react';
import { useAppContext } from '@/context';
import { ModalHook } from '@/hooks/useModal';
import { AppModal, Flex, LoadingSpin } from '@/components';
import useDormitoryRoomMembers from '@/hooks/app/useDormitoryRoomMembers';
import { Alert, Card, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

export interface RoomMembersModalProps extends ModalHook {
  data: {
    dormitory: IdName;
    room: DormitoryFloorRoomEntity;
    floor: DormitoryFloorEntity;
    blockId: number;
  }
}

export default function RoomMembersModal({
  open,
  data,
  hide,
}: RoomMembersModalProps) {

  const { mode } = useAppContext();
  const { members, loading, fetchDormitoryRoomMembers, } = useDormitoryRoomMembers();

  const [t] = useTranslation(['common', 'dormitory']);

  useEffect(() => {
    if (!data?.room) return;
    const { dormitory, blockId, floor, room } = data;
    fetchDormitoryRoomMembers(dormitory.id, blockId, floor.id, room.id);
  }, [data?.room]);

  return (
    <AppModal
      centered
      destroyOnClose
      footer={null}
      open={open}
      variant={mode}
      onCancel={hide}
      style={{ maxWidth: '90%' }}
      title={t('dormitory:labels.show-room-members')}
    >
      <Flex direction="column" justify="center" align="center" className="w-full min-h-[50px]">
        {loading ? <LoadingSpin text="" /> : (
          <Row className="w-full" gutter={[8, 8]}>
            {members.length === 0 && (
              <Col span={24}>
                <Alert className="h-full text-center" type="warning" message={t('dormitory:messages.no-one-selected-room')} />
              </Col>
            )}
            {members.map((member) => (
              <Col key={member?.id} span={24}>
                <Card size="small">
                  <div>
                    <span className="font-medium">{member?.user?.firstName} {member?.user.lastName}</span>
                    <span className="ms-0.5">({member?.user?.student?.studentNumber})</span>
                  </div>
                  <div>{member?.user?.student?.studyLevel?.name} - {member?.user?.student?.studyMajor?.name}</div>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Flex>
    </AppModal>
  );
}
